import styled from "styled-components";


export const Loading = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    position: fixed;
    background-color: ${props => props.theme.backgrounds.white};
    justify-content: center;
    align-items: center;
`;